import Team from '../components/Team';

const TeamPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-neutral-50 pt-20">
      <Team />
    </div>
  );
};

export default TeamPage;
